import script from "./pointsOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./pointsOrder.vue?vue&type=script&setup=true&lang=js"

import "./pointsOrder.vue?vue&type=style&index=0&id=7e0af499&lang=scss"

const __exports__ = script;

export default __exports__